<!-- drag and drop area -->
<div
  class="grid flex-1 grid-cols-[6fr_1px_4fr] grid-rows-[auto_1fr] gap-x-8 h-full"
>
  <!-- headlines -->
  <div class="col-span-1 flex flex-col justify-center mb-3">
    <p class="text-xs font-semibold text-content-title">
      {{ 'ANALYSIS.CREATE_CONFIGURATION.DATA_FIELDS' | translate }}
    </p>
  </div>

  <div class="bg-border col-span-1"></div>

  <div class="col-span-1 flex flex-col justify-center mb-3">
    <p class="text-xs font-semibold text-content-title">
      {{ 'ANALYSIS.CREATE_CONFIGURATION.ANALYSIS_HIERARCHY' | translate }}
    </p>
  </div>

  <!-- unassigned items -->
  @let unassignedGroupColumns = this.unassignedGroupColumns();
  <div
    class="col-span-1 row-start-2 flex flex-row flex-wrap gap-2 overflow-scroll content-start"
    cdkDropList
    [cdkDropListOrientation]="'mixed'"
    [cdkDropListData]="unassignedGroupColumns"
    [cdkDropListConnectedTo]="['hierarchy']"
    (cdkDropListDropped)="onDrop($event)"
    id="unassignedGroupColumns"
  >
    @for (unassignedGroupColumn of unassignedGroupColumns; track $index) {
      <pm-group-column-item
        class="self-start"
        cdkDrag
        [name]="unassignedGroupColumn"
      />
    }
  </div>

  <!-- divider -->
  <div class="bg-border col-span-1 row-start-2"></div>

  <!-- hierarchy -->
  @let hierarchy = this.hierarchy();
  <div
    class="flex flex-col col-span-1 gap-3 overflow-auto min-w-full min-h-full"
    cdkDropList
    [cdkDropListOrientation]="'vertical'"
    [cdkDropListData]="hierarchy"
    [cdkDropListConnectedTo]="['unassignedGroupColumns']"
    id="hierarchy"
    (cdkDropListDropped)="onDrop($event)"
  >
    @for (hierarchyItem of hierarchy; track $index) {
      <div class="flex flex-row gap-3 items-center">
        <p class="text-xs font-bold text-content-title">{{ $index + 1 }}</p>
        <pm-group-column-item cdkDrag [name]="hierarchyItem" />
      </div>
    }
  </div>
</div>
